'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconThreeCirclesAscendingContainer, iconThreeCirclesAscendingContainerTag } from '@ni/nimble-components/dist/esm/icons/three-circles-ascending-container';
import { wrap } from '../../utilities/react-wrapper';

export type { IconThreeCirclesAscendingContainer };
export { iconThreeCirclesAscendingContainerTag };
export const NimbleIconThreeCirclesAscendingContainer = wrap(IconThreeCirclesAscendingContainer);